import React from 'react';
import PropTypes from 'prop-types';
import useCountUp from '../../../hooks/useCountUp';

/**
 * A headline rate with an animated bar underneath — the "Completion Rate"
 * pattern from the reference. The bar grows via a width transition, so it
 * animates without a chart library.
 */
const RateCard = ({ title, rowLabel, percent, caption, accent }) => {
  const safePercent = Number.isFinite(percent) ? Math.max(0, Math.min(100, percent)) : null;
  const animated = useCountUp(safePercent ?? 0);

  return (
    <div className="bg-white dark:bg-shoorah-darkBgTabColor border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder rounded-2xl p-4 md:p-5 flex flex-col gap-3">
      <h4 className="text-base font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
        {title}
      </h4>

      <div className="flex items-center justify-between gap-3">
        <span className="text-sm text-shoorah-gray4 dark:text-shoorah-darkBg">{rowLabel}</span>
        <span className="text-sm font-semibold text-shoorah-lightBlack dark:text-shoorah-darkBg tabular-nums">
          {safePercent === null ? '—' : `${Math.round(animated)}%`}
        </span>
      </div>

      <div className="h-2 rounded-full bg-shoorah-normanGray dark:bg-shoorah-darkBgColor overflow-hidden">
        <div
          className="h-full rounded-full transition-[width] duration-700 ease-out motion-reduce:transition-none"
          style={{ width: `${safePercent ?? 0}%`, backgroundColor: accent }}
        />
      </div>

      {caption ? <p className="text-xs text-shoorah-gray3">{caption}</p> : null}
    </div>
  );
};

RateCard.propTypes = {
  title: PropTypes.string.isRequired,
  rowLabel: PropTypes.string.isRequired,
  percent: PropTypes.number,
  caption: PropTypes.string,
  accent: PropTypes.string
};

RateCard.defaultProps = {
  accent: '#1F1F1F'
};

export default RateCard;
